import React, { useState, useEffect } from 'react';

// Старый ключ (для совместимости с уже принявшими) + новый, который читает index.html для PostHog
const LEGACY_KEY = 'kladoffka_cookies_accepted';
const CONSENT_KEY = 'kladoffka_cookie_consent';   // значение 'accepted' активирует аналитику

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem(CONSENT_KEY) === 'accepted'
                  || localStorage.getItem(LEGACY_KEY) === '1';
    if (!accepted) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem(CONSENT_KEY, 'accepted');
    localStorage.setItem(LEGACY_KEY, '1');         // backward compatibility
    // index.html слушает этот event для активации PostHog без релоада
    try { window.dispatchEvent(new Event('kladoffka:consent-accepted')); } catch (e) {}
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-foreground text-background border-t-2 border-black px-4 py-4 md:py-5">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <p className="font-mono text-sm leading-relaxed text-background/80 max-w-2xl">
          Мы используем файлы <span className="text-white font-bold">cookie</span> для улучшения работы сайта.
          Продолжая использование сайта, вы соглашаетесь с нашей{' '}
          <a href="/privacy" className="underline hover:text-accent transition-colors">политикой конфиденциальности</a>.
        </p>
        <button
          onClick={accept}
          className="shrink-0 bg-accent text-white font-mono text-sm uppercase tracking-widest px-8 py-3 hover:bg-accent/90 transition-all hover:translate-y-[-1px] active:translate-y-0 border-2 border-transparent hover:border-white/20"
        >
          Хорошо
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
